import createGlobalState from "@ui/lib/createGlobalState";
import * as io from "io-ts";

export const useBreaksBetweenGroups = createGlobalState({
  storage: "session",
  key: "break-between-groups",
  type: io.boolean,
  defaultValue: true,
  scoped: true,
});
